@let validationViewModel = validationViewModel$ | async;
<div class="validation-container">
  <div class="body-header">
    <span class="casto-title large" [innerHTML]="'validation.kitchen.title'|translate"></span>
  </div>
  @if (!featureSettingsService.poseEnabled || !featureSettingsService.financementEnabled || !featureSettingsService.fidelityEnabled) {
    <div class="panel-content feature-disabled-panel d-flex flex-column gap-2" style="margin-bottom: 24px;">
      @if (!featureSettingsService.poseEnabled) {
        <p class="alert alert-warning m-0" [innerHTML]="'feature-settings.warning.pose' | translate"></p>
      }
      @if (!featureSettingsService.financementEnabled) {
        <p class="alert alert-warning m-0" [innerHTML]="'feature-settings.warning.financement' | translate"></p>
      }
      @if (!featureSettingsService.fidelityEnabled) {
        <p class="alert alert-warning m-0" [innerHTML]="'feature-settings.warning.fidelity' | translate"></p>
      }
    </div>
  }
  @if (!loading) {
    <div class="panel-content" id="prices">
      <div class="casto-card">
        <div
          [class]="validationViewModel.currentInstallation.withInstallation ? 'content withInstallation' : 'content'">
          <table class="price-table">
            <tr class="top-row">
              <td>
                @if (validationViewModel.currentInstallation.withInstallation) {
                  <span
                    class="casto-title"
                    [innerHTML]="
                      'validation.kitchen.with-installation'
                        | translate
                          : {
                              tva: validationViewModel.currentInstallation.more2Years ? 10 : 20,
                            }
                    "></span>
                } @else {
                  <span class="casto-title" [innerHTML]="'validation.kitchen.without-installation' | translate"></span>
                }
              </td>
              <td>
                @if (validationViewModel.displayDiscount) {
                  <span
                    class="casto-tag"
                    [innerHTML]="
                              'installation.kitchen.with-installation.top-row-tag'
                                | translate
                                  : {
                                      discount: validationViewModel.discountNumberValue,
                                      discountAmount:
                                        (-validationViewModel.currentPricing.totalWithoutFunding.discountedAmount
                                        | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'),
                                    }
                            "></span>
                }
              </td>
              <td>
                @if (validationViewModel.displayDiscount) {
                  <span
                    class="casto-discount"
                    [innerHTML]="
                              validationViewModel.currentPricing.totalWithoutFunding.baseAmount
                                | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                            "></span>
                }
              </td>
              <td>
                <span
                  class="blue"
                  [innerHTML]="
                    (featureSettingsService.financementEnabled
                      ? validationViewModel.currentPricing.totalWithFunding
                      : validationViewModel.currentPricing.totalWithoutFunding?.actualAmount)
                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                  ">
                </span>
              </td>
            </tr>

            @if (validationViewModel.currentComplementaryProduct?.hasRemovedProducts) {
              <tr class="warning-row">
                <td colspan="4">
                  <div class="removed-products-warning" [innerHTML]="'complementary-products.removed-products-warning'|translate"></div>
                </td>
              </tr>
            }

            @if (featureSettingsService.financementEnabled) {
              <tr class="funding">
              <td [innerHTML]="'validation.kitchen.funding-label'|translate">
              </td>
              <td></td>
              <td></td>
              <td>
                <span class="blue"
                      [innerHTML]="'validation.kitchen.funding'|translate:{
                                mensuality: validationViewModel.funding?.mensuality|currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                                duration: validationViewModel.funding?.duration,
                                interest: validationViewModel.funding?.interest|currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                }">
                </span>

              </td>
            </tr>
            }
            <!-- Ligne dédiée pour le sous-tableau -->
            <tr>
              <td class="inner-table-cell">
                <table class="inner-table">
                  @for (detail of validationViewModel.currentPricing.detailConception | keyvalue; track detail.key; ) {
                    <tr>
                      <td [innerHTML]="'installation.kitchen.conception-details.'+detail.key|translate"></td>

                      <td>
                        @if (validationViewModel.displayDiscount) {

                          <span class="casto-tag"
                                [innerHTML]="(-detail.value.discountedAmount)| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                                </span>

                        }
                      </td>
                      <td>
                        @if (validationViewModel.displayDiscount) {
                          <span class="casto-discount"
                                [innerHTML]="detail.value.baseAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>


                        }
                      </td>
                      <td class="price">
                                  <span
                                    [innerHTML]="detail.value.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                            </span>

                      </td>
                    </tr>
                  }
                </table>
              </td>
            </tr>

            @if (validationViewModel.isCustomWorkbenchOnly) {
              <tr>
                <td class="inner-table-cell">
                  <table class="inner-table">
                    <tr>
                      <td [innerHTML]="'installation.kitchen.workbench.total-without-packages'|translate">
                      </td>
                      <td>
                        @if (validationViewModel.displayDiscount) {
                          <span class="casto-tag"
                                [innerHTML]="-validationViewModel.extraPricing.totalWorkbench.discountedAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>


                        }
                      </td>
                      <td>
                        @if (validationViewModel.displayDiscount) {
                          <span class="casto-discount"
                                [innerHTML]="validationViewModel.extraPricing.totalWorkbench.baseAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>


                        }
                      </td>
                      <td>
                                  <span class="blue"
                                        [innerHTML]="validationViewModel.extraPricing.totalWorkbench.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                    </span>

                      </td>
                  </table>
              </tr>
            } @else if (validationViewModel.isCustomWorkbench) {
              <tr>
                <td class="inner-table-cell">
                  <table class="inner-table">
                    <tr>
                      <td class="horizontal-align-with-gap">
                        <span [innerHTML]="'installation.kitchen.workbench.total' | translate"></span>
                        <ng-casto-button class="secondary"
                                         (click)="openDetailWorkbench()"
                                         [label]="'installation.kitchen.workbench.details' | translate"></ng-casto-button>
                      </td>
                      <td>
                        @if (validationViewModel.displayDiscount) {
                          <span class="casto-tag"
                                [innerHTML]="validationViewModel.extraPricing.totalWorkbench.discountedAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>


                        }
                      </td>
                      <td>
                        @if (validationViewModel.displayDiscount) {
                          <span class="casto-discount"
                                [innerHTML]="validationViewModel.extraPricing.totalWorkbench.baseAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>


                        }
                      </td>
                      <td>
                                  <span class="blue"
                                        [innerHTML]="validationViewModel.extraPricing.totalWorkbench.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                    </span>

                      </td>
                    </tr>
                    @if (validationViewModel.extraPricing.totalWorkbenchPlan) {
                      <tr>
                        <td [innerHTML]="'installation.kitchen.workbench.custom'|translate">
                        </td>
                        <td></td>
                        <td></td>
                        <td class="price">
                                    <span
                                      [innerHTML]="validationViewModel.extraPricing.totalWorkbenchPlan.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                                  </span>

                        </td>
                      </tr>
                    }
                    @if (validationViewModel.extraPricing.totalInstallation) {
                      <tr>
                        <td [innerHTML]="'installation.kitchen.workbench.installation-package'|translate">
                        </td>
                        <td></td>
                        <td></td>
                        <td class="price">
                                    <span
                                      [innerHTML]="validationViewModel.extraPricing.totalInstallation.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                                  </span>

                        </td>
                      </tr>
                    }
                    @if (validationViewModel.extraPricing.totalDelivery) {
                      <tr>
                        <td [innerHTML]="'installation.kitchen.workbench.delivery-package'|translate">
                        </td>
                        <td></td>
                        <td></td>
                        <td class="price">
                                    <span
                                      [innerHTML]="validationViewModel.extraPricing.totalDelivery.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                                  </span>

                        </td>
                      </tr>
                    }
                  </table>
                </td>
              </tr>
            } @else {
              <tr>
                <td [innerHTML]="'installation.kitchen.workbench.default-workbench'|translate">
                </td>
                <td>
                  @if (validationViewModel.displayDiscount) {
                    <span class="casto-tag"
                          [innerHTML]="-validationViewModel.extraPricing.HBMWorkbench.discountedAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>


                  }
                </td>
                <td>
                  @if (validationViewModel.displayDiscount) {
                    <span class="casto-discount"
                          [innerHTML]="validationViewModel.extraPricing.HBMWorkbench.baseAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>


                  }
                </td>
                <td class="price">
                            <span
                              [innerHTML]="validationViewModel.extraPricing.HBMWorkbench.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                                  </span>

                </td>
              </tr>
            }
            @if (validationViewModel.currentPricing.totalComplementaryProduct?.actualAmount > 0) {
              <tr>
                <td [innerHTML]="'validation.kitchen.complementary-product'|translate">
                </td>
                <td>
                  @if (validationViewModel.displayDiscount) {
                    <span class="casto-tag"
                          [innerHTML]="-validationViewModel.currentPricing.totalComplementaryProduct.discountedAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>

                  }
                </td>
                <td>
                  @if (validationViewModel.displayDiscount) {
                    <span class="casto-discount"
                          [innerHTML]="validationViewModel.currentPricing.totalComplementaryProduct.baseAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>


                  }
                </td>
                <td class="price">
                            <span
                              [innerHTML]="validationViewModel.currentPricing.totalComplementaryProduct.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                                  </span>

                </td>
              </tr>
            }
            <tr>
              <td [innerHTML]="'installation.kitchen.delivery'|translate">
              </td>
              <td></td>
              <td></td>
              <td>
                <span class="blue"
                      [innerHTML]="validationViewModel.currentPricing.delivery.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                </span>
              </td>
            </tr>
            @if (validationViewModel.currentPricing.totalInstallation && validationViewModel.currentInstallation.withInstallation) {
              <tr>
                <td>
                  <div class="horizontal-align-with-gap">
                    <span [innerHTML]="'installation.kitchen.with-installation.installation' | translate"></span>
                    <ng-casto-button
                      class="secondary"
                      (click)="openDetail()"
                      [label]="'installation.kitchen.with-installation.details' | translate"></ng-casto-button>
                  </div>
                </td>
                <td></td>
                <td></td>
                <td>
                            <span class="blue"
                                  [innerHTML]="validationViewModel.currentPricing.totalInstallation.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                    </span>

                </td>
              </tr>
            }
          </table>
        </div>
        @if (fidelityEnabled()) {
          <div class="footer">
            <div class="fidelity-container">

              @if (validationViewModel.currentCustomer.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUM) {
                <div class="c-casto-container" id="ccasto">
                  <img src="assets/img/c-castoprice.svg" alt="c-casto" class="c-casto">
                  @if (validationViewModel.fidelityLoading || !validationViewModel.currentFidelity) {
                    <div class="loader-container">
                      <ng-casto-loader></ng-casto-loader>
                    </div>
                  } @else {
                    @if (validationViewModel.currentFidelity?.freeCardCoupons.length > 0) {
                      <div class="rewards-container">
                        <div
                          class="rewards-title">@if (validationViewModel.currentCustomer.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE ||
                        validationViewModel.currentCustomer.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE0) {
                          <span [innerHtml]="'validation.fidelity.ccasto-upgrade-title'|translate"></span>
                        } @else {
                          <span [innerHTML]="'validation.fidelity.rewards'|translate:{
                  value:validationViewModel.currentFidelity?.freeCardEarnedPoints,
                  s:(validationViewModel.currentFidelity?.freeCardEarnedPoints > 1 )? 's': ''
                  }"></span>
                        }

                        </div>
                        <div class="rewards-detail">
                          <div class="rewards-subtitle">
                            @if (validationViewModel.currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE || validationViewModel.currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE0) {
                              <span
                                [innerHtml]="'validation.fidelity.ccasto-upgrade-subtitle'|translate:{ coupons: validationViewModel.currentFidelity?.freeCardCoupons | freeCardCouponRewards }"></span>
                            } @else {
                              <span
                                [innerHtml]="'validation.fidelity.ccasto-rewards'|translate:{ coupons: validationViewModel.currentFidelity?.freeCardCoupons | freeCardCouponRewards }"></span>
                            }
                          </div>
                          <div class="action">
                            @if (validationViewModel.currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE || validationViewModel.currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE0) {
                              <ng-casto-button class="primary"
                                               [label]="'validation.fidelity.subscribe-free'|translate"
                                               (click)="createFreeCard()"></ng-casto-button>
                            }
                          </div>
                        </div>
                      </div>
                    } @else {
                      <div class="no-rewards-container">
                        <span class="no-rewards" [innerHTML]="'validation.fidelity.no-rewards'|translate"></span>
                        <div class="action">
                          @if (validationViewModel.currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE ||
                          validationViewModel.currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE0) {
                            <ng-casto-button
                              class="primary"
                              [label]="'validation.fidelity.subscribe-free' | translate"
                              (click)="createFreeCard()"></ng-casto-button>
                          }
                        </div>
                      </div>
                    }
                  }
                </div>
              }

              <div class="c-casto-container" id="ccasto-max">

                <img src="assets/img/c-castomaxprice.svg" alt="c-castomax" class="c-casto">
                @if (validationViewModel.fidelityLoading || !validationViewModel.currentFidelity) {
                  <div class="loader-container">
                    <ng-casto-loader></ng-casto-loader>
                  </div>
                } @else {

                  @if (validationViewModel.premiumCardEarnedCoupons > 0) {
                    <div class="rewards-container">
                      <div class="rewards-title">
                        @if (validationViewModel.currentCustomer.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUM) {
                          <span [innerHTML]="'validation.fidelity.ccasto-max-upgrade-title'|translate:{
                  value:validationViewModel.currentFidelity?.premiumCardEarnedPoints,
                  s:(validationViewModel.premiumCardEarnedCoupons > 1 )? 's': ''
                  }"></span>
                        } @else {
                          @if (validationViewModel.isCardExpired) {
                            <span [innerHTML]="'validation.fidelity.ccasto-max-renew-title'|translate:{
                 }"></span>
                          } @else {
                            <span [innerHTML]="'validation.fidelity.ccasto-max-rewards'|translate:{
                  value:validationViewModel.currentFidelity?.premiumCardEarnedPoints,
                  count:validationViewModel.premiumCardEarnedCoupons,
                  s:(validationViewModel.premiumCardEarnedCoupons > 1 )? 's': ''
                  }"></span>
                          }

                        }

                      </div>

                      <div class="rewards-detail">
                        @if (validationViewModel.currentCustomer.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUM) {

                          <div class="rewards-subtitle"
                               [innerHTML]="'validation.fidelity.ccasto-max-upgrade-subtitle'|translate :{
                       count: validationViewModel.premiumCardEarnedCoupons,

                       value: validationViewModel.currentFidelity?.premiumCardCoupons[0]?.value,
                  s:(validationViewModel.premiumCardEarnedCoupons > 1 )? 's': ''
                       }"></div>
                        } @else if (validationViewModel.isCardExpired) {
                          <div class="rewards-subtitle"
                               [innerHTML]="'validation.fidelity.ccasto-max-rewards'|translate :{
                        value:validationViewModel.currentFidelity?.premiumCardEarnedPoints,
                        count:validationViewModel.premiumCardEarnedCoupons,
                      s:(validationViewModel.premiumCardEarnedCoupons > 1 )? 's': ''
                  }"></div>
                        }
                        <div class="action">
                          @if (validationViewModel.currentCustomer?.fidelity?.cardIsPaidButNotActiveYet) {
                            <span [innerHTML]="'validation.fidelity.ccasto-max-waiting-activation'|translate"></span>
                            <ng-casto-button class="primary"
                                             [label]="'validation.fidelity.refresh'|translate"
                                             (click)="refreshFidelity()"
                                             [loading]="refreshLoading"></ng-casto-button>
                          } @else if (validationViewModel.isCardExpired && validationViewModel.currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.PREMIUM) {
                            <ng-casto-button class="primary"
                                             [label]="'validation.fidelity.renew'|translate"
                                             (click)="updatePremiumCard()"></ng-casto-button>
                          } @else if (validationViewModel.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUM
                          && validationViewModel.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUMWAITING) {
                            <ng-casto-button class="primary"
                                             [label]="'validation.fidelity.subscribe'|translate"
                                             (click)="createPremiumCard()"></ng-casto-button>
                          } @else if (validationViewModel.currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.PREMIUMWAITING) {
                            <ng-casto-button class="primary"
                                             [label]="'validation.fidelity.pay'|translate"
                                             (click)="getPaymentLink()"></ng-casto-button>
                          }

                        </div>
                      </div>
                    </div>
                  } @else {
                    <div class="no-rewards-container">
                      <span class="no-rewards" [innerHTML]="'validation.fidelity.no-rewards'|translate"></span>
                      <div class="action">
                        @if (validationViewModel.currentCustomer?.fidelity?.cardIsPaidButNotActiveYet) {
                          <span [innerHTML]="'validation.fidelity.ccasto-max-waiting-activation'|translate"></span>
                          <ng-casto-button class="primary"
                                           [label]="'validation.fidelity.refresh'|translate"
                                           (click)="refreshFidelity()"
                                           [loading]="refreshLoading"></ng-casto-button>
                        } @else if (validationViewModel.isCardExpired && validationViewModel.currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.PREMIUM) {
                          <ng-casto-button class="primary"
                                           [label]="'validation.fidelity.renew'|translate"
                                           (click)="updatePremiumCard()"></ng-casto-button>
                        } @else if (validationViewModel.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUM
                        && validationViewModel.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUMWAITING) {
                          <ng-casto-button class="primary"
                                           [label]="'validation.fidelity.subscribe'|translate"
                                           (click)="createPremiumCard()"></ng-casto-button>
                        } @else if (validationViewModel.currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.PREMIUMWAITING) {
                          <ng-casto-button class="primary"
                                           [label]="'validation.fidelity.pay'|translate"
                                           (click)="getPaymentLink()"></ng-casto-button>
                        }

                      </div>
                    </div>

                  }
                }

              </div>
            </div>
          </div>
        }
      </div>
    </div>
    @if (featureSettingsService.poseEnabled) {
      @if (!validationViewModel.currentWithInstallation) {
      <div class="panel-content" (click)="setWithInstallation(true)" id="installation">
        <div class="casto-card">
          <div class="header">
          <span class="casto-title" [innerHTML]="'installation.kitchen.with-installation.title'|translate : {
          amount: validationViewModel.currentPricing?.delta?.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
          }"></span>
            <ng-casto-button class="primary" [label]="'generic.details'|translate"
                             (click)="setWithInstallation(true)"></ng-casto-button>
          </div>
        </div>
      </div>
    } @else {
      <div class="panel-content" (click)="setWithInstallation(false)" id="installation">
        <div class="casto-card">
          <div class="header">
          <span class="casto-title" [innerHTML]="'installation.kitchen.without-installation.title'|translate : {
          amount: validationViewModel.currentPricing?.delta.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
          }"></span>
            <ng-casto-button class="primary" [label]="'generic.details'|translate"
                             (click)="setWithInstallation(false)"></ng-casto-button>
          </div>
        </div>
      </div>
      }
    }
  } @else {
    <div class="loader-container">
      <ng-casto-loader></ng-casto-loader>
    </div>
  }


</div>

